import { DataProviderArgs } from "../../DataStore/DataProvider";

import { GraphQLTable } from "./GraphQLTable";
import { IWarning } from "../cloud/WarningsTable";

export class WarningTable extends GraphQLTable<IWarning> {
    constructor(args: DataProviderArgs) {
        super(args, [], { get: "getWarning", list: "listWarnings", create: "createWarning" });
    }
}
